import { render } from "./OurVision.vue?vue&type=template&id=389995f2"
import script from "./OurVision.vue?vue&type=script&lang=js"
export * from "./OurVision.vue?vue&type=script&lang=js"

import "./OurVision.vue?vue&type=style&index=0&id=389995f2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__